import { Layout } from 'antd';
import { ReactNode } from 'react';

import { useMobileVersion } from '../../hooks/useMobileVersion';
import { useSidebarCollapse } from '../../hooks/useSidebarCollapse';
import { Breadcrumb } from './Breadcrumb';
import {
  DefaulterAckModal,
  DefaulterBanner,
  DefaulterBlock,
  useDefaulterNotice,
} from './DefaulterNotice';
import { Sidebar } from './Sidebar';
import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_WIDTH } from './Sidebar/styles';
import { Header } from './Header';
import { ContentStyled } from './styles';

interface PanelLayoutProps {
  children: ReactNode;
}

export const PanelLayout = ({ children }: PanelLayoutProps) => {
  const isMobileVersion = useMobileVersion();
  const { isCollapsed } = useSidebarCollapse();
  const { notice, setNotice, customerName } = useDefaulterNotice();

  const content = (
    <>
      <DefaulterBanner notice={notice} customerName={customerName} />
      <DefaulterBlock notice={notice} customerName={customerName}>
        {children}
      </DefaulterBlock>
      <DefaulterAckModal
        notice={notice}
        customerName={customerName}
        onAcknowledged={() =>
          setNotice(notice ? { ...notice, ack_required: false } : notice)
        }
      />
    </>
  );

  return (
    <Layout>
      {isMobileVersion ? (
        <>
          <Header />
          <ContentStyled $isMobileVersion={isMobileVersion}>
            {content}
          </ContentStyled>
        </>
      ) : (
        <>
          <Sidebar />
          <ContentStyled
            $isMobileVersion={false}
            $sidebarWidth={isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH}
          >
            <Breadcrumb />
            {content}
          </ContentStyled>
        </>
      )}
    </Layout>
  );
};
